import {
  MembersActionTypes,
  GenderInfo,
  PaymentTermInfo,
  MemberStatusInfo,
  Member,
  ProgramMemberInfo,
  TestHistoryInfo,
  TestResultInfo,
  MaxAttendanceInfo,
  MembersDetailsMode,
  MemberType,
  MemberStatusCode,
  MembersState,
  PaymentInfo,
  PaymentTermCode,
  GenderCode
} from './members.types';
import { PayerInfo, PayMethodsInfo } from 'src/billing/billing.types';
import { PaymentMethod, CAD } from 'src/billing/billing.const';
import { PaymentMethodType } from 'src/payments/Types';
import { DEFAULT_PROGRAM_ID, DEFAULT_LEVEL_ID } from 'src/programs/Constants';

export const YEAR_3000_PACKAGE_BASED_END_DATE = 32503680000000;

export const GET_MEMBERS: MembersActionTypes = 'GET_MEMBERS';
export const GET_MEMBER: MembersActionTypes = 'GET_MEMBER';
export const REGISTER_MEMBER: MembersActionTypes = 'REGISTER_MEMBER';
export const UPDATE_MEMBER: MembersActionTypes = 'UPDATE_MEMBER';
export const BULK_CANCEL: MembersActionTypes = 'BULK_CANCEL';
export const BULK_ADD_DAYS_TO_END_DATES: MembersActionTypes = 'BULK_ADD_DAYS_TO_END_DATES';
export const BULK_SEND_EMAILS: MembersActionTypes = 'BULK_SEND_EMAILS';
export const BULK_SEND_SMS: MembersActionTypes = 'BULK_SEND_SMS';
export const CREATE_PAYMENT: MembersActionTypes = 'CREATE_PAYMENT';
export const UPDATE_PAYMENT: MembersActionTypes = 'UPDATE_PAYMENT';
export const CANCEL_PAYMENT: MembersActionTypes = 'CANCEL_PAYMENT';
export const CREATE_NEW_MEMBER: MembersActionTypes = 'CREATE_NEW_MEMBER';
export const PAYMENTS_TABLE_ROW_CLICKED: MembersActionTypes = 'PAYMENTS_TABLE_ROW_CLICKED';
export const PAYMENTS_TABLE_ROW_UNCLICKED: MembersActionTypes = 'PAYMENTS_TABLE_ROW_UNCLICKED';
export const NEW_MEMBER_PAYMENT_CLICKED: MembersActionTypes = 'NEW_MEMBER_PAYMENT_CLICKED';
export const UPDATE_SCHEDULED_PAYMENT: MembersActionTypes = 'UPDATE_SCHEDULED_PAYMENT';
export const ACTIVATE_MEMBERSHIP_BUTTON_CLICKED: MembersActionTypes = 'ACTIVATE_MEMBERSHIP_BUTTON_CLICKED';
export const GET_ABSENT_MEMBERS: MembersActionTypes = 'GET_ABSENT_MEMBERS';
export const EXPORT_CSV: MembersActionTypes = 'EXPORT_CSV';

export const MAX_NOTE_LENGTH = 255;

export class DefaultMemberPictureURL {
  public static readonly MALE: string = require('../img/anonymous.png');
  public static readonly FEMALE: string = require('../img/anonymous.png');
}

export const genders: Array<GenderInfo> = [
  {
    code: 'MALE',
    name: 'Male'
  },
  {
    code: 'FEMALE',
    name: 'Female'
  }
];

export const MONTHLY: PaymentTermCode = 'MONTHLY';
export const YEARLY: PaymentTermCode = 'YEARLY';
export const BI_WEEKLY: PaymentTermCode = 'BI_WEEKLY';
export const WEEKLY: PaymentTermCode = 'WEEKLY';

export const paymentTerms: Array<PaymentTermInfo> = [
  // {
  //   code: 'WEEKLY',
  //   name: 'Weekly'
  // },
  // {
  //   code: 'BI_WEEKLY',
  //   name: 'Bi-Weekly'
  // },
  {
    code: MONTHLY,
    name: 'Monthly'
  },
  {
    code: YEARLY,
    name: 'Yearly'
  }
];

export const paymentTermsCC: Array<PaymentTermInfo> = [
  {
    code: WEEKLY,
    name: 'Weekly'
  },
  {
    code: BI_WEEKLY,
    name: 'Bi-Weekly'
  },
  {
    code: MONTHLY,
    name: 'Monthly'
  },
  {
    code: YEARLY,
    name: 'Yearly'
  }
];

export const EXPIRED: MemberStatusCode = 'EXPIRED';
export const ACTIVE: MemberStatusCode = 'ACTIVE';
export const CANCELLED: MemberStatusCode = 'CANCELLED';

export const memberStatus: Array<MemberStatusInfo> = [
  {
    code: ACTIVE,
    name: 'Active'
  },
  {
    code: EXPIRED,
    name: 'Expired'
  },
  {
    code: CANCELLED,
    name: 'Cancelled'
  }
];

export const testResults: Array<TestResultInfo> = [
  {
    code: 'PASS',
    name: 'Pass'
  },
  {
    code: 'FAIL',
    name: 'Fail'
  }
];

export const maxAttendances: Array<MaxAttendanceInfo> = [
  {
    code: 0,
    name: 'N/A'
  },
  {
    code: 1,
    name: '1 Day'
  },
  {
    code: 2,
    name: '2 Days'
  },
  {
    code: 3,
    name: '3 Days'
  },
  {
    code: 4,
    name: '4 Days'
  },
  {
    code: 5,
    name: '5 Days'
  },
  {
    code: 6,
    name: '6 Days'
  },
  {
    code: 7,
    name: '7 Days'
  }
];

export const DEFAULT_MEMBER_ID = 0;

export const CLASS_BASED: MemberType = 'CLASS_BASED';
export const TIME_BASED: MemberType = 'TIME_BASED';
export const PACKAGE_BASED: MemberType = 'PACKAGE_BASED';

export const DEFAULT_PAYER: PayerInfo = {
  id: 0,
  firstName: '',
  lastName: '',
  initial: '',
  email: '',
  mobile1: '',
  mobile2: '',
  address: '',
  city: '',
  province: '',
  country: '',
  postalCode: '',
  payingMembers: []
};

export const DEFAULT_PAY_METHOD_ID = 0;

export const defaultPaymentMethodWith = (p: PaymentMethodType): PayMethodsInfo => {
  return {
    id: DEFAULT_PAY_METHOD_ID,
    paymentMethodType: p,
    accountHolderName: '',
    financialInstitutionName: '',
    transitNumber: '',
    maskedTransitNumber: '',
    financialInstitutionNumber: '',
    bankAccountNumber: '',
    maskedBankAccountNumber: '',
    cardNumber: '',
    cardHolderName: '',
    expiryMonth: '',
    expiryYear: '',
    cvc: '',
    payer: undefined
  };
};

export const DEFAULT_ZERO_AMOUNT_STRING = '0.00';
export const DEFAULT_PAYMENT_ID = 0;
export const DEFAULT_AMOUNT_PER_TRANSACTION = 0;
export const DEFAULT_DOWN_PAYMENT = 0;
export const DEFAULT_TOTAL = 0;

export const DEFAULT_PAYMENT: PaymentInfo = {
  id: DEFAULT_PAYMENT_ID,
  payer: DEFAULT_PAYER,
  paymentType: 'DEBIT',
  paymentMethod: defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE),
  amountPerTransaction: DEFAULT_AMOUNT_PER_TRANSACTION,
  downPayment: DEFAULT_DOWN_PAYMENT,
  total: DEFAULT_TOTAL,
  currency: CAD,
  startDate: new Date().getTime(),
  numberOfTransactions: 1,
  term: MONTHLY,
  continuous: false,
  paymentHistories: [],
  scheduleDetails: [],
  active: false
};

export const MALE: GenderCode = 'MALE';
export const FEMALE: GenderCode = 'FEMALE';
export const DEFAULT_POINT = 0;
export const DEFAULT_AGE = 0;
export const DEFAULT_MAX_ATTENDANCE_PER_WEEK = 0;
export const DEFAULT_REMAINING_CLASSES = 0;

/**
 * Creditcard or voidcheque number of Transaction cannot be 0. Cash number of transaction is always 1. 
 */
export const initialMemberDetail: Member = {
  id: DEFAULT_MEMBER_ID,
  firstName: '',
  lastName: '',
  initial: '',
  email: '',
  mobile1: '',
  mobile2: '',
  gender: MALE,
  birthDate: new Date().getTime(),
  note: '',
  address: '',
  city: '',
  province: '',
  country: '',
  postalCode: '',
  startDate: new Date().getTime(),
  endDate: new Date().getTime(),
  point: DEFAULT_POINT,
  memberId: '',
  picUrl: '',
  payments: [
    DEFAULT_PAYMENT
  ],
  programMembers: [],
  smsConsent: false,
  emailConsent: false,
  age: DEFAULT_AGE,
  contractDuration: '',
  maxAttendancePerWeek: DEFAULT_MAX_ATTENDANCE_PER_WEEK,
  posHistories: [],
  testHistories: [],
  cancelled: false,
  remainingClasses: DEFAULT_REMAINING_CLASSES,
  memberType: CLASS_BASED,
  programNames: [],
  tags: [],
  packageIds: [],
  emergencyContactName1: '',
  emergencyContactNumber1: '',
  emergencyContactName2: '',
  emergencyContactNumber2: '',
  emergencyContactName3: '',
  emergencyContactNumber3: '',
  checkinNotification: 'NONE',
  lastCheckInDate: new Date().getTime()
};

export const DEFAULT_PROGRAM_MEMBER_INFO_ID = 0;

export const initialProgramMemberDetail: ProgramMemberInfo = {
  id: DEFAULT_PROGRAM_MEMBER_INFO_ID,
  program: {
    id: DEFAULT_PROGRAM_ID,
    name: '',
    schedules: [],
    levels: []
  },
  level: {
    id: DEFAULT_LEVEL_ID,
    level: '',
    requiredAttendance: 0
  },
  schedules: []
};

export const initialTestHistoryDetail: TestHistoryInfo = {
  id: 0,
  programId: 0,
  programName: '',
  levelId: 0,
  level: '',
  testResult: 'PASS',
  testDate: new Date().getTime()
};

export const DISPLAY: MembersDetailsMode = 'DISPLAY';
export const EDIT: MembersDetailsMode = 'EDIT';
export const CREATE: MembersDetailsMode = 'CREATE';
export const AUTO_ATTENDANCE: MembersDetailsMode = 'AUTO_ATTENDANCE';
export const MANUAL_ATTENDANCE: MembersDetailsMode = 'MANUAL_ATTENDANCE';

export const initialMembersState: MembersState = {
  statusCode: 0,
  members: [],
  member: JSON.parse(JSON.stringify(initialMemberDetail)),
  newMember: undefined,
  paymentsTableRowClicked: false,
  newMemberPaymentClicked: false
};

export const NOT_AVAILABLE = 'N/A';
export const UNASSIGNED = 'UNASSIGNED';
export const ONE_WEEK = '1 Week';
export const TWO_WEEK = '2 Week';
export const THREE_WEEK = '3 Week';
export const FOUR_WEEK = '4 Week';
export const MENU_WEEKS = [NOT_AVAILABLE, ONE_WEEK, TWO_WEEK, THREE_WEEK, FOUR_WEEK];



// WEBPACK FOOTER //
// ./src/members/members.constants.tsx